module.exports = __webpack_public_path__ + "static/barkpoint-16179c2e5b0e9b4f22af02bea1032a30.jpg";